import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './DAcApplication.css';
import React, { useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ProgressApplication from './components/ProgressApplication';
import StepsProvider from './components/StepsProvider';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get, getDictionaryItem } from '../../utils';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { GetAllLookups, GetDetails } from './components/actions';
import { forEach, find } from 'lodash';
import Cookies from 'js-cookie';
import { parsePhoneNumber } from 'react-phone-number-input';
export var EStatus = /*#__PURE__*/function (EStatus) {
  EStatus["Inactive"] = "INACTIVE";
  EStatus["Active"] = "ACTIVE";
  EStatus["Completed"] = "COMPLETED";
  return EStatus;
}({});
var Application = function Application(props) {
  var fields = props.fields,
    params = props.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _fields$data = fields.data,
    configuration = _fields$data.configuration,
    dictionaryApplicantDetails = _fields$data.dictionaryApplicantDetails,
    dictionaryNavigation = _fields$data.dictionaryNavigation,
    dictionaryPassportDetails = _fields$data.dictionaryPassportDetails,
    dictionaryPaymentSubmitApplication = _fields$data.dictionaryPaymentSubmitApplication,
    dictionaryUploadDocument = _fields$data.dictionaryUploadDocument,
    settings = _fields$data.settings,
    countries = _fields$data.countries;
  var apiKey = get(settings, 'apiKey.jss.value') || '';
  var apiUrl = get(settings, 'apiUrl.jss.value') || '';
  var serviceId = get(settings, 'serviceId.jss.value') || null;
  var loginPage = get(settings, 'loginPage.jss.value.href') || '';
  var availableNationalities = get(settings, 'availableNationalities.targetItems') || [];
  var countriesList = get(countries, 'countryValues') || [];
  var sessionId = Math.random().toString(16).slice(2);
  var dashboardUrl = get(configuration, 'buttonBackUrl.jss.value.href') || '/';
  var initialSteps = [{
    id: 0,
    title: get(configuration, 'pdNavigationTitle.jss.value') || '',
    status: EStatus.Active,
    dictionary: dictionaryPassportDetails,
    dictionaryNavigation: dictionaryNavigation,
    validateMessage: getDictionaryItem(dictionaryPassportDetails, 'validateError'),
    data: _objectSpread({
      availableNationalities: availableNationalities,
      title: {
        value: get(configuration, 'pdTitle.jss.value') || ''
      },
      shortDescription: get(configuration, 'pdShortDescription.jss.value') || ''
    }, configuration)
  }, {
    id: 1,
    title: get(configuration, 'adNavigationTitle.jss.value') || '',
    status: EStatus.Inactive,
    dictionary: dictionaryApplicantDetails,
    dictionaryNavigation: dictionaryNavigation,
    validateMessage: getDictionaryItem(dictionaryPassportDetails, 'validateError'),
    data: _objectSpread({
      title: {
        value: get(configuration, 'adTitle.jss.value') || ''
      },
      countriesList: countriesList,
      shortDescription: get(configuration, 'adShortDescription.jss.value') || ''
    }, configuration)
  }, {
    id: 2,
    title: get(configuration, 'udNavigationTitle.jss.value') || '',
    status: EStatus.Inactive,
    dictionary: dictionaryUploadDocument,
    dictionaryNavigation: dictionaryNavigation,
    validateMessage: getDictionaryItem(dictionaryPassportDetails, 'validateError'),
    data: _objectSpread({
      title: {
        value: get(configuration, 'udTitle.jss.value') || ''
      },
      shortDescription: get(configuration, 'udShortDescription.jss.value') || ''
    }, configuration)
  }, {
    id: 3,
    title: get(configuration, 'pSaNavigationTitle.jss.value') || '',
    status: EStatus.Inactive,
    dictionary: dictionaryPaymentSubmitApplication,
    dictionaryNavigation: dictionaryNavigation,
    validateMessage: getDictionaryItem(dictionaryPassportDetails, 'validateError'),
    data: _objectSpread({
      title: {
        value: get(configuration, 'pSaTitle.jss.value') || ''
      },
      dashboardUrl: dashboardUrl,
      shortDescription: get(configuration, 'pSaShortDescription.jss.value') || ''
    }, configuration)
  }];
  var history = useHistory();
  var _useLocation = useLocation(),
    search = _useLocation.search;
  var searchParams = new URLSearchParams(search);
  var appn = searchParams.get('appn');
  var stepId = searchParams.get('step');
  var componentRef = useRef(null);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    applicationNumber = _useState2[0],
    setApplicationNumber = _useState2[1];
  var _useState3 = useState(initialSteps),
    _useState4 = _slicedToArray(_useState3, 2),
    steps = _useState4[0],
    setSteps = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    context = _useState6[0],
    setContext = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    documents = _useState8[0],
    setDocuments = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    lookups = _useState10[0],
    setLookups = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isLoadingWizard = _useState12[0],
    seIsLoadingWizard = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    userTokken = _useState14[0],
    setUserTokken = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    username = _useState16[0],
    setUsername = _useState16[1];
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    isTranslateAvaible = _useState18[0],
    setIsTranslateAvaible = _useState18[1];
  var currentStep = steps.slice().reverse().find(function (_ref) {
    var status = _ref.status;
    return status === EStatus.Active;
  });
  var currentStepId = currentStep && currentStep.id || 0;
  var clickStep = function clickStep(id) {
    setSteps(steps.map(function (step, index) {
      if (id === step.id) {
        step.status = EStatus.Active;
      } else if (step.status === EStatus.Active && id < index) step.status = EStatus.Inactive;else if (step.status === EStatus.Active) step.status = EStatus.Completed;
      return step;
    }));
  };
  var clickBackButton = function clickBackButton(e) {
    e.preventDefault();
    if (currentStepId === 0) {
      history.push(dashboardUrl);
      return;
    }
    clickStep(currentStepId - 1);
  };
  var getLookupOptions = function getLookupOptions(name) {
    var lookup = find(lookups, function (props) {
      var lookupName = Object.keys(props);
      if (lookupName && lookupName[0] === name) return props;
    });
    return lookup && lookup[name] || [];
  };
  useEffect(function () {
    function fetchSelectOption() {
      return _fetchSelectOption.apply(this, arguments);
    }
    function _fetchSelectOption() {
      _fetchSelectOption = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              seIsLoadingWizard(true);
              _context.next = 3;
              return GetAllLookups({
                apiKey: apiKey,
                apiUrl: apiUrl,
                sessionId: sessionId,
                userTokken: userTokken
              });
            case 3:
              response = _context.sent;
              setLookups(response);
              seIsLoadingWizard(false);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _fetchSelectOption.apply(this, arguments);
    }
    var tokken = Cookies.get('token');
    var userNameCookie = Cookies.get('username');
    if (userNameCookie) setUsername(userNameCookie);
    if (!tokken) {
      history.push(loginPage);
    } else {
      setUserTokken(tokken);
    }
    fetchSelectOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    function fetchApp() {
      return _fetchApp.apply(this, arguments);
    }
    function _fetchApp() {
      _fetchApp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var newContext;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (appn) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              seIsLoadingWizard(true);
              setApplicationNumber(appn);
              _context2.next = 6;
              return GetDetails({
                apiKey: apiKey,
                apiUrl: apiUrl,
                sessionId: sessionId,
                userTokken: userTokken
              }, appn);
            case 6:
              newContext = _context2.sent;
              forEach(newContext, function (value, name) {
                if (name === 'addressOutsideTelNo') {
                  var collectValue = value;
                  var code = '';
                  var parsedmobileNo = parsePhoneNumber("+".concat(value));
                  if (parsedmobileNo) {
                    collectValue = parsedmobileNo.nationalNumber;
                    code = parsedmobileNo.countryCallingCode;
                  }
                  updateContext(_defineProperty2({}, name, _objectSpread(_objectSpread({}, context[name]), {}, {
                    value: collectValue,
                    code: code,
                    valid: true
                  })));
                } else {
                  updateContext(_defineProperty2({}, name, _objectSpread(_objectSpread({}, context[name]), {}, {
                    value: value,
                    valid: true
                  })));
                }
              });
              seIsLoadingWizard(false);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _fetchApp.apply(this, arguments);
    }
    if (lookups.length) fetchApp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookups]);
  useEffect(function () {
    if (stepId) {
      var _currentStepId = parseInt(stepId) - 1;
      clickStep(_currentStepId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepId]);
  useEffect(function () {
    if (applicationNumber.length) Cookies.set('applicationNumber', applicationNumber);
  }, [applicationNumber]);
  var updateContext = function updateContext(data) {
    setContext(function (state) {
      return _objectSpread(_objectSpread({}, state), data);
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "wizard",
    ref: componentRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group  module-group--inside d-block  d-sm-none"
  }, /*#__PURE__*/React.createElement("a", {
    href: "##",
    className: "link back-button",
    onClick: clickBackButton
  }, /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon"
  }), ' ', getDictionaryItem(dictionaryNavigation, 'NavigationBack'))), /*#__PURE__*/React.createElement("div", {
    className: "wizard__header"
  }, /*#__PURE__*/React.createElement(ProgressApplication, {
    rtl: rtl,
    steps: steps,
    className: "module-group module-group--inside"
  })), /*#__PURE__*/React.createElement(StepsProvider, {
    rtl: rtl,
    context: context,
    appRef: componentRef,
    currentStepId: currentStepId,
    updateSteps: clickStep,
    steps: steps,
    updateContext: updateContext,
    getLookupOptions: getLookupOptions,
    lookups: lookups,
    applicationNumber: applicationNumber,
    appn: appn,
    setApplicationNumber: setApplicationNumber,
    documents: documents,
    setDocuments: setDocuments,
    apiConfig: {
      apiKey: apiKey,
      apiUrl: apiUrl,
      serviceId: serviceId,
      sessionId: sessionId,
      userTokken: userTokken,
      redirectUrl: loginPage,
      history: history,
      dashboardUrl: dashboardUrl,
      username: username
    },
    isLoadingWizard: isLoadingWizard,
    isTranslateAvaible: isTranslateAvaible,
    setIsTranslateAvaible: setIsTranslateAvaible
  })));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " ".concat(fullWidthStyles, " ").concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default Application;
var commonStyles = "ctk59l5";
var fullWidthStyles = "f1yxvp0";
var rtlStyles = "rq4h6cz";
var ltrStyles = "l1msews6";